<template>
  <div id="header">
    <h1>
      <img src="@/assets/img/rate-my-tactic--light.png" :alt="$t('R.title')" />
    </h1>
    <div>
      <select @change="switchLanguage">
        <option
          v-for="language in languages"
          :key="language.code"
          :value="language.code"
          :selected="language.code === $route.params.lang"
        >
          {{ language.name }}
        </option>
      </select>
      <a
        href="http://crowdl.io/ratemytactic/entries/"
        target="_blank"
        style="margin: 12px; font-size: 12px"
        >Translation</a
      >
    </div>
    <h3 id="subtitle">
      Previously the answer to the question "why is my tactic so crap?"
    </h3>

    <p class="intro-paragraph">
      RATE MY TACTIC is no longer being actively developed or maintained due to
      changes since Football Manager 2026. The substantial changes to the
      tactics system from that game onwards mean substantial changes would have
      to be made to the rating system. RATE MY TACTIC will remain online for the
      foreseeable future to help players that still want to play previous
      versions of the game. Thanks for all the love over the years!
    </p>

    <div>
      <h5>
        A huge thank you to everyone that supported RATE MY TACTIC throughout
        its development! The largest contributors are now commemorated on the
        tactics board for posterity.
      </h5>
    </div>

    <p class="intro-paragraph">
      RATE MY TACTIC builds on the fantastic guides available at
      <a href="https://www.guidetofm.com" target="_blank">guidetofm.com</a> and
      <a href="https://www.guidetofootball.com" target="_blank"
        >guidetofootball.com</a
      >. If you'd like to learn more about football tactics and how to create a
      successful one for Football Manager, then we highly recommend visiting
      both of those sites.
    </p>
  </div>
</template>

<script>
export default {
  name: "TheHeader",

  data: () => {
    return {
      languages: [
        { name: "Bulgarian", code: "bg" },
        { name: "Deutsch", code: "de" },
        { name: "English", code: "en" },
        { name: "Français", code: "fr" },
        { name: "Italiano", code: "it" },
        { name: "Português", code: "pt" },
        { name: "Português (Brasil)", code: "pt-br" },
      ],
    };
  },

  methods: {
    switchLanguage: function (e) {
      this.$router.push(`/${e.target.value}`);
    },
  },
};
</script>

<style scoped>
h1 {
  display: inline-block;
  max-width: 100%;
  text-transform: uppercase;
}

h1 img {
  width: 100%;
  max-height: 15vh;
}

@media only screen and (max-width: 767px) {
  .mobile-hide {
    display: none;
  }

  #header {
    padding: 16px;
  }

  #subtitle {
    font-size: medium;
  }

  .intro-paragraph {
    font-size: small;
  }

  h5 {
    margin: 12px 0 0;
  }
}
</style>
